// @revopush/react-native-code-push is native. App.js wraps the root as
// `codePush(options)(App)` and references codePush.SyncStatus / InstallMode /
// restartApp. Shim as a passthrough HOC + the enum/method surface.
function codePush() {
  return function (App) {
    return App;
  };
}
codePush.InstallMode = { IMMEDIATE: 0, ON_NEXT_RESTART: 1, ON_NEXT_RESUME: 2 };
codePush.SyncStatus = {
  CHECKING_FOR_UPDATE: 0, DOWNLOADING_PACKAGE: 1, INSTALLING_UPDATE: 2,
  UP_TO_DATE: 3, UPDATE_INSTALLED: 4, UNKNOWN_ERROR: 5,
  SYNC_IN_PROGRESS: 6, AWAITING_USER_ACTION: 7,
};
codePush.CheckFrequency = { ON_APP_START: 0, ON_APP_RESUME: 1, MANUAL: 2 };
codePush.restartApp = function () {};
codePush.sync = function () { return Promise.resolve(codePush.SyncStatus.UP_TO_DATE); };
codePush.getUpdateMetadata = function () { return Promise.resolve(null); };
codePush.notifyAppReady = function () { return Promise.resolve(); };
module.exports = codePush;
module.exports.default = codePush;
